import React from 'react'
import {Payment ,BreadCrumb} from '../components'
const CheckOutPage = () => {
    return (
        <main>
            <BreadCrumb title='Check out' cart product/>
            <Payment/>
        </main>
    )
}

export default CheckOutPage
